'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc service
 * @name $montantFormat
 * @function
 *
 * @description
 * Montant formatter.
 *
 */
ngModule.factory("$montantFormat", function (stringUtils, currencyService, parametrageMontantProviderService) {
  var defaultPlaceHolder = "-";
  var $montantFormat = function $montantFormat(montant, fixedDecimals, signed, unite) {
    if (montant == null || montant.valeur == null) {
      return defaultPlaceHolder;
    }
    var isSigned = !_.isUndefined(signed) && signed !== false;
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (parametrageMontantProviderService.cacherDecimales()) {
      format = "0,0";
    } else if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.00";
    }
    var valeur = montant.valeur;
    var currencySign = currencyService.getCurrencySign(montant.devise);
    if (unite == null) {
      unite = parametrageMontantProviderService.getUniteAffichageMontant();
    }
    if (unite === 'K') {
      currencySign = 'K' + currencySign;
      valeur = valeur / 1000.0;
    } else if (unite === 'M') {
      currencySign = 'M' + currencySign;
      valeur = valeur / 1000000.0;
    }
    var formatted = numeral(valeur).format(format);

    // todo - sans doute à intégrer dans la pattern de format
    if (isSigned) {
      if (numeral(montant.valeur) > 0.0000001) {
        formatted = "+ " + formatted;
      }
    }
    var estimated = montant.type === "ESTIME" || montant.type === "SIMULE";
    return formatted + " " + currencySign + (estimated ? " *" : "");
  };
  _.extend($montantFormat, {
    /**
     *
     * @param {Montant} montant
     * @param {number=} nbDecimals
     * @param {signed=} optional,  si présent et non à false met toujours le signe (+/- always displayed).
     * @param {unite=} optional,  si K ou M met en millier ou million.
     * @returns {string} The formatter montant.
     */
    montant: function montant(_montant, nbDecimals, signed, unite) {
      return $montantFormat(_montant, nbDecimals, signed, unite);
    },
    /**
     *
     * @param montantAsNumber un nombre (le montant)
     * @param devise la devise, par defaut EUR
     * @param nbDecimals
     * @param signed
     * @param unite
     * @returns {string|string}
     */
    number: function number(montantAsNumber, nbDecimals, devise, signed, unite) {
      var montant = null;
      if (montantAsNumber != null) {
        montant = {
          valeur: montantAsNumber,
          devise: devise || 'EUR'
        };
      }
      return $montantFormat(montant, nbDecimals, signed, unite);
    }
  });
  return $montantFormat;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/montant/montantFormat.js
// module id = 2731
// module chunks = 13